"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Hitagi_Constraints {
    constructor(media_constraints) {
        this.constraints = {};
        this.video_bitrate = 0;
        this.audio_bitrate = 0;
        this.reencode = false;
        if (media_constraints) {
            if (media_constraints.video_bitrate) {
                this.video_bitrate = media_constraints.video_bitrate;
                delete media_constraints.video_bitrate;
            }
            if (media_constraints.audio_bitrate) {
                this.audio_bitrate = media_constraints.audio_bitrate;
                delete media_constraints.audio_bitrate;
            }
            this.reencode = media_constraints.reencode ? true : false;
            delete media_constraints.reencode;
            this.constraints = media_constraints;
        }
    }
    get() {
        return this.constraints;
    }
    get_without_devices() {
        // Let's copy constraints
        const constraints = JSON.parse(JSON.stringify(this.constraints));
        for (const k in constraints) {
            delete constraints[k]["deviceId"];
        }
        return constraints;
    }
    set_device_id(Section, Value) {
        this.set_constraint(Section, "deviceId", { "exact": Value });
    }
    set_preferred_video_quality(width, height) {
        this.set_video_quality("ideal", width, height);
    }
    set_minimal_video_quality(width, height) {
        this.set_video_quality("min", width, height);
    }
    set_maximal_video_quality(width, height) {
        this.set_video_quality("max", width, height);
    }
    set_video_quality(Kind, Width, Height) {
        if (!(this.constraints.video instanceof Object)) {
            this.constraints.video = {};
        }
        if (!(this.constraints.video.width instanceof Object) ||
            !(this.constraints.video.height instanceof Object)) {
            this.constraints.video.width = {};
            this.constraints.video.height = {};
        }
        this.constraints.video.width[Kind] = Width;
        this.constraints.video.height[Kind] = Height;
    }
    set_constraint(Section, Name, Value) {
        if (!(this.constraints[Section] instanceof Object)) {
            this.constraints[Section] = {};
        }
        this.constraints[Section][Name] = Value;
    }
    enable_audio_processing(value) {
        this.set_echo_cancellation(value);
        this.set_noise_suppression(value);
    }
    set_noise_suppression(value) {
        return this.set_constraint("audio", "noiseSuppression", value);
    }
    set_echo_cancellation(value) {
        return this.set_constraint("audio", "echoCancellation", value);
    }
    set_echo_cancellation_type(value) {
        return this.set_constraint("audio", "echoCancellationType", value);
    }
    set_auto_gain_control(value) {
        return this.set_constraint("audio", "autoGainControl", value);
    }
}
exports.default = Hitagi_Constraints;



//////////////////
// WEBPACK FOOTER
// ./node_modules/hitagi-js/build/hitagi_constraints.js
// module id = ./node_modules/hitagi-js/build/hitagi_constraints.js
// module chunks = main